var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"404"},[_c('h2',[_vm._v("404 - Not Found")]),_c('p',[_vm._v("お探しのページは見つかりませんでした。")]),_c('p',[_vm._v(_vm._s(_vm.url))])])}
var staticRenderFns = []

export { render, staticRenderFns }